import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * GPTEventsApi
 * Provides access to GPT prompt usage events for analytics dashboards.
 * Endpoint base: /api/stats/gpt/prompts/events
 * Supports filtering by: userId, conversationId, correlationId, promptType, documentId, from, to, page, size
 */
export const GPTEventsApi = {
  /**
   * Fetch paginated prompt events
   * @param {Object} filters
   * @param {number} [filters.userId]
   * @param {number} [filters.conversationId]
   * @param {string} [filters.correlationId]
   * @param {string} [filters.promptType]
   * @param {number} [filters.documentId]
   * @param {string|Date} [filters.from] ISO timestamp or Date
   * @param {string|Date} [filters.to] ISO timestamp or Date
   * @param {number} [filters.page=0]
   * @param {number} [filters.size=50]
   * @returns {Promise<Response>} fetch Response
   */
  getPromptEvents: async (filters = {}) => {
    const params = new URLSearchParams();
    const {
      userId,
      conversationId,
      correlationId,
      promptType,
      documentId,
      from,
      to,
      page = 0,
      size = 50,
    } = filters;

    if (userId) params.set('userId', userId);
    if (conversationId) params.set('conversationId', conversationId);
    if (correlationId) params.set('correlationId', correlationId);
    if (promptType) params.set('promptType', promptType);
    if (documentId) params.set('documentId', documentId);
    if (from) params.set('from', typeof from === 'string' ? from : from.toISOString());
    if (to) params.set('to', typeof to === 'string' ? to : to.toISOString());
    if (page != null) params.set('page', page);
    if (size != null) params.set('size', size);

    const qs = params.toString();
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/stats/gpt/prompts/events${qs ? `?${qs}` : ''}`, { method: 'GET' });
  },
};

export default GPTEventsApi;
